<template>
  <div
    class="greenness-score-container"
    :class="{ 'slide-in-bck-center': useAnimations }"
    :style="gaugeStyles">
    <img
      v-if="!isGaugeVisible && showGreenLeaf"
      class="slide-in-bck-center"
      src="/assets/images/green-deals-icon.svg"
      style="width: 100%; height: 100%"
      alt=""
      @mouseenter="
        () => {
          if (props.isAnimating) {
            isGaugeVisible = true;
          }
        }
      " />
    <gauge
      v-if="isGaugeVisible || !showGreenLeaf"
      :class="{ 'rotate-in-2-cw': useAnimations }"
      :inline="inline"
      :value="props.co2Score"
      :min="0"
      :max="100"
      :style="gaugeStyles"
      :color-stops="[
        { percentage: 0, color: '#ff0083' },
        { percentage: 0.25, color: '#FFDF02' },
        { percentage: 0.75, color: '#00e074' },
        { percentage: 1, color: '#00a156' },
      ]"
      @mouseenter="
        () => {
          if (props.isAnimating) {
            isGaugeVisible = true;
          }
        }
      "
      @mouseleave="isGaugeVisible = false">
      <template #value>
        <div
          v-if="!inline && showNumber"
          style="display: flex; flex-direction: column; align-items: center; justify-content: center">
          <span class="score-number">{{ Math.round(props.co2Score) }}</span>
        </div>
      </template>
    </gauge>
    <div
      v-if="inline && showNumber"
      style="display: flex; flex-direction: column; align-items: center; justify-content: center">
      <span>{{ Math.round(props.co2Score) }}</span>
    </div>
    <div
      v-if="isGaugeVisible"
      class="gauge-badge slide-in-bck-center badge badge-rounded badge-default badge-xs">
      {{ capitalize($t('messages.sustainability')) }}
    </div>
  </div>
</template>

<script setup lang="ts">
  //#region Imports

  import { capitalize, computed, Ref, ref } from 'vue';

  import Gauge from '@/common/components/controls/Gauge.vue';

  //#endregion

  //#region Props

  interface IGreenScoreProps {
    co2Score: number;
    isAnimating?: boolean;
    useAnimations?: boolean;
    showGreenLeaf?: boolean;
    showNumber?: boolean;
    inline?: boolean;
    width?: string;
    height?: string;
  }

  const props = withDefaults(defineProps<IGreenScoreProps>(), {
    co2Score: 50,
    isAnimating: true,
    useAnimations: true,
    showGreenLeaf: true,
    showNumber: true,
    inline: false,
  });

  //#endregion

  //#region Data

  const isGaugeVisible: Ref<boolean> = ref(false);

  //#endregion

  const gaugeStyles = computed(() => {
    return {
      width: props.width || '100%',
      height: props.height || '100%',
    };
  });
</script>

<style lang="scss" scoped>
  @use 'sass:color';
  @use '@/styles/variables.scss' as *;

  .greenness-score-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .gauge-badge {
    position: fixed;
    max-width: 100vw;
    bottom: -3rem;
    z-index: 10;
  }
  .score-number {
    font-family: $monospace-font-family;
  }
</style>
